import { useQuery } from '@tanstack/react-query';
import { StatCardGrid } from '@/components/common/StatCardGrid';
import { leaveApplicationSummaryQueryOptions } from '../api/leaveApplications.api';
import { SUMMARY_CARDS } from '../constants/leaveApplication.constants';
import type { LeaveApplicationSummaryParams } from '../types/leaveApplication.types';

interface LeaveApplicationSummaryCardsProps {
  params: LeaveApplicationSummaryParams;
}

export function LeaveApplicationSummaryCards({ params }: LeaveApplicationSummaryCardsProps) {
  const { data, isLoading, isError } = useQuery(leaveApplicationSummaryQueryOptions(params));

  return (
    <StatCardGrid
      stats={SUMMARY_CARDS.map((card) => ({ ...card, value: data?.[card.key] }))}
      isLoading={isLoading}
      isError={isError}
    />
  );
}
